import React from "react"
import { Box, Stack, Typography } from "@mui/material"
import CheckIcon from "@mui/icons-material/Check"
import { PSE_BLOCK_TYPES } from "../../../../utils/productionStepExecution"
import { COLORS } from "../../../../utils"

const sx = {
  sectionCard: {
    borderRadius: "8px",
    border: "1px solid " + COLORS.BLACK_200,
    backgroundColor: "#FFF",
    padding: "16px",
  },
  title: {
    fontSize: "20px",
    fontWeight: 500,
    lineHeight: 1.4,
    color: COLORS.BLACK_800
  },
  value: {
    fontSize: "18px",
    fontWeight: 400,
    lineHeight: 1.33,
    color: COLORS.BLACK_800
  },
  subtitle: {
    fontSize: "18px",
    fontWeight: 400,
    lineHeight: 1.33,
    color: COLORS.BLACK_700
  },
  label: {
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: 1.5,
    color: COLORS.LABEL_GREY
  },
  chip: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    padding: "4px 8px",
    borderRadius: "24px",
    border: `1px solid ${COLORS.GREEN_SUCCESS_300}`,
    backgroundColor: COLORS.GREEN_SUCCESS_50,
  },
  chipText: {
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px",
    color: COLORS.GREEN_SUCCESS_800,
  }
}

const sxIcon = {
  preparation: {
    backgroundColor: COLORS.GREEN_SUCCESS_100,
  },
  weights: {
    backgroundColor: COLORS.BLACK_200,
  },
  ingredients: {
    backgroundColor: COLORS.YELLOW_100,
  },
  cooling: {
    backgroundColor: COLORS.BLUE_50,
  },
  cooking: {
    backgroundColor: COLORS.ORANGE_100,
  },
  icon: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "52px",
    height: "52px",
    borderRadius: "8px",
  }
}

const PSESection = ({
  sectionType = PSE_BLOCK_TYPES.PREPARATION,
  title,
  subtitle,
  description,
  children,
  spacing = 3,
  fishParasiteCheckDone = false,
  renderTopRight = () => null
}) => {
  return (
    <Stack sx={sx.sectionCard} spacing={spacing}>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Stack direction="row" spacing={"12px"} alignItems="center">
          <Box sx={{ ...sxIcon.icon, ...sxIcon[sectionType] }}>
            <img src={`/icons/pses/${sectionType}.svg`} alt={sectionType} />
          </Box>
          <Stack spacing={1}>
            <Typography sx={sx.title}>{title}</Typography>
            {subtitle && <Typography sx={sx.subtitle}>{subtitle}</Typography>}
          </Stack>
        </Stack>
        {fishParasiteCheckDone && (
          <Box sx={sx.chip} className="flex">
            <Typography sx={sx.chipText}>Contrôle anisakis</Typography>
            <CheckIcon sx={{ fontSize: "22.86px", color: COLORS.GREEN_SUCCESS_800 }} />
          </Box>
        )}
        {renderTopRight()}
      </Stack>
      {description && <Typography sx={sx.value}>{description}</Typography>}
      <div>
        {children}
      </div>
    </Stack>
  )
}

export default PSESection